import React from 'react';

import Text from '@lightspeed/cirrus-text';
import cn from 'classnames';
import PropTypes from 'prop-types';

const baseClass = 'cr-form-field';

const FormField = ({
  children,
  id,
  label,
  description,
  textHelper,
  status,
  className,
  ...rest
}) => {
  const formFieldClass = cn(baseClass, className);

  const statusHelperClass = cn(`${baseClass}__text-helper`, {
    [`${baseClass}__text-helper--${status && status.type}`]: status && status.type,
  });

  const descriptionMarkup = description ? (
    <div className="cr-gray cr-text-s cr-pb-1">{description}</div>
  ) : null;

  const statusHelperMarkup =
    status && status.message ? (
      <Text element="div" bodySmall className={statusHelperClass}>
        {status.message}
      </Text>
    ) : null;

  const textHelperMarkup = textHelper ? (
    <Text element="div" bodySmall dimmed className={`${baseClass}__text-helper`}>
      {textHelper}
    </Text>
  ) : null;

  return (
    <div className={formFieldClass} {...rest}>
      <label htmlFor={id}>
        {!!label && (
          <Text
            element="div"
            bodySmall
            bold
            className={cn({ [`${baseClass}__text-label`]: !description })}
          >
            {label}
          </Text>
        )}
        {descriptionMarkup}
        {children}
      </label>
      {statusHelperMarkup || textHelperMarkup}
    </div>
  );
};

FormField.propTypes = {
  children: PropTypes.node.isRequired,
  id: PropTypes.string,
  label: PropTypes.string,
  description: PropTypes.string,
  textHelper: PropTypes.string,
  status: PropTypes.shape({
    type: PropTypes.oneOf(['valid', 'warning', 'error']),
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  }),
  className: PropTypes.string,
};

// For internal use only, we'll soon create a helper function to set and get
// this value. It would also be a good idea to automate the process for all
// components and add this in a build step. We want to avoid using `displayName`
// as its already used for devtools purpose and is part .
//
// @TODO use underscore dangle to mark it as private in the helper function
// and disable `no-underscore-dangle` eslint rule there.
FormField.cirrusName = 'FormField';

export default FormField;
